import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import DefaultImage from 'assets/images/digital/default-download-image.jpg'
import styles from './styles.scss'

const imageUrl = ({ options }, images) => {
  if (options && options.download_image_id){
    const image = images[options.download_image_id]
    if (image && image.large_url){
      return image.large_url
    }
  }

  return DefaultImage
}

class Download extends Component {
  render(){
    const {
      brand: { colour_primary, colour_highlight },
      artworks,
      campaignProposal,
      images,
    } = this.props
    const artwork = artworks[campaignProposal.artwork]
    const buttonBackground = `#${colour_primary}` || null
    const buttonTextColor = `#${colour_highlight}` || null

    if (!artwork) return null

    return (
      <div className={styles.root} style={{ backgroundImage: `url(${imageUrl(campaignProposal, images)})` }}>
        <p className={styles.text}>Click to download the proposal thats been prepared for your property.</p>
        <a
          href={artwork.links.download_url}
          className={styles.button}
          style={{ backgroundColor: buttonBackground, color: buttonTextColor }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faDownload} style={{ marginRight: 5 }} /> Download PDF
        </a>
      </div>
    )
  }
}

Download.propTypes = {
  brand: PropTypes.object.isRequired,
  artworks: PropTypes.object,
  campaignProposal: PropTypes.object.isRequired,
  images: PropTypes.object.isRequired,
}

export default Download
